import { render, staticRenderFns } from "./CoreDataLoader.vue?vue&type=template&id=83830c20&"
import script from "./CoreDataLoader.vue?vue&type=script&lang=js&"
export * from "./CoreDataLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports